document.addEventListener(
  "click",
  function (e) {
    const el = e.target.closest("a, summary");
    if (!el) return;

    const isDesktopMenu = el.closest(".nav-desktop__tier-1");
    const isMobileMenu = el.closest("#mobile_menu");

    if (!isDesktopMenu && !isMobileMenu) return;
    const clickedText = el.innerText.trim();
    const isDesktopSubmenu = !!el.closest(
      ".nav-desktop__tier-2, .nav-desktop__tier-3, .mega-menu",
    );
    const mobileListItem = isMobileMenu ? el.closest("li") : null;
    const mobileParentSublink = mobileListItem?.parentElement?.closest(
      "li.sublink",
    );
    const isMobileSubmenu = !!mobileParentSublink;
    const isSubmenu = isDesktopSubmenu || isMobileSubmenu;

    let menuSection = clickedText;
    let submenuSection = "";

    if (isSubmenu) {
      // Desktop submenu clicks should be attributed to the tier-1 menu section.
      if (isDesktopSubmenu) {
        const tier1Item = el.closest(".nav-desktop__tier-1-item");
        const tier1Title = tier1Item
          ?.querySelector("[data-nav-desktop-link] [data-nav-title]")
          ?.textContent?.trim();

        menuSection = tier1Title || clickedText;
        submenuSection = clickedText;
      } else {
        // Mobile submenu clicks should use the parent sublink title as section.
        const mobileTitle =
          mobileParentSublink
            ?.querySelector("[data-nav-title]")
            ?.textContent?.trim() ||
          mobileParentSublink?.querySelector("a")?.textContent?.trim();

        menuSection = mobileTitle || clickedText;
        submenuSection = clickedText;
      }
    }

    Shopify.analytics.publish("menu_bar_interaction", {
      menu_section: menuSection.toUpperCase(),
      submenu_section: submenuSection.toUpperCase(),
      page_path: window.location.pathname,
      page_title: document.title,
      page_location: window.location.href,
    });
  },
  true,
);

document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector(".search-form");

  if (form) {
    form.addEventListener("submit", function () {
      const value = form.querySelector(".search-form__input")?.value.trim();

      if (value) {
        Shopify.analytics.publish("search_submitted", {
          search_term: value,
        });
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = new URL(window.location.href);
  const pageNumber = currentUrl.searchParams.get("page");
  const navEntry = performance.getEntriesByType("navigation")[0];
  const isReload = navEntry?.type === "reload";

  if (!pageNumber || isReload) return;

  Shopify.analytics.publish("pagination", {
    value: String(pageNumber).toUpperCase(),
    page_path: currentUrl.pathname + currentUrl.search,
    page_title: document.title,
    page_location: currentUrl.href,
  });
});


